import "@fontsource-variable/hanken-grotesk";
import "@fontsource-variable/geist-mono";
import "@fontsource/instrument-serif/400.css";
import "@/app/styles/globals.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/app";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
